// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../pr6433-npm11211-20261015/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #0255A5;
  --primary-color-rgb:2, 85, 165;
  --primary-color-hover:#0F3B66;
  --primary-color-opacity: rgba(2, 85, 165, 0.1);
  --light-grey:#F9F9F9;
  --light-grey-rgb:249, 249, 249;
  --dark-grey:#9A9C9F;
  --dark-grey-rgb:154, 156, 159;
  --darkGrey:#1b232c;
  --hover-bg-color:#E4E8EF;
  --white-bg-hover:#e8eff2;
  --light-blue:#6A80A9;
  --purple:#675081;
  --purple-rgb:103, 80, 129;
  --textHighlightBgColor:rgba(191, 219, 253, 0.90);
  --textHighlightFontColor:var(--primary-font-color);
  --primary-font-color: var(--surface-500);
  --primary-font-color-rgb: var(--surface-500-rgb);
  --secondary-font-color: var(--surface-700);
  --disabled-font-color:#828b97;
  --font:"Open Sans", Arial, sans-serif;
  --h1:24px;
  --h2:18px;
  --h3:16px;
  --h4:13px;
  --bodyFontSize:14px;
  --tableFontSize:12px;
  --pageTitleSize:var(--h1);
  --sectionTitleSize:var(--h2);
  --sectionSubTitleSize:var(--tableFontSize);
  --sectionTitleLabel:var(--h3);
  --accordionTitleSize:var(--sectionTitleSize);
  --border-color: var(--surface-100);
  --darkBorderColor: var(--textHighlightFontColor);
  --table-border-color:#E8EFF2;
  --table-border-style:1px solid var(--table-border-color);
  --border-style:1px solid var(--border-color);
  --border-lg-radius:8px;
  --border-m-radius:4px;
  --border-m-radius-top:4px 4px 0px 0px;
  --border-m-radius-bottom:0px 0px 4px 4px;
  --border-sm-radius:2px;
  --border-radius-tab:2px 2px 0px 0px;
  --selected-text:#E4E8EF;
  --selected-bg:#E4E8EF;
  --table-alt-row-color: var(--light-grey);
  --alert-warning:#D6BA17;
  --alert-warning-rgb:214, 186, 23;
  --alert-warning-opacity: rgba(214, 186, 23, 0.10);
  --alert-success:#02a570;
  --alert-success-rgb:2, 165, 112;
  --alert-success-opacity: rgba(2, 165, 112, 0.10);
  --alert-info: var(--primary-color);
  --alert-info-rgb: var(--primary-color-rgb);
  --alert-info-opacity: rgba(2, 85, 165, 0.11);
  --alert-danger:#E02222;
  --alert-danger-rgb:224, 34, 34;
  --alert-danger-opacity: rgba(224, 34, 34, 0.10);
  --alert-danger-hover: #871a1a;
  --alert-medium:#F97031;
  --alert-medium-rgb:249, 112, 49;
  --brown:#5b4434;
  --notification-warning-bg:#FAF8E7;
  --notification-info-bg:#E5EEF6;
  --notification-error-bg:#FBE8E8;
  --notification-success-bg:#E5F6F0;
  --shadow-color:rgba(89,101,118,0.32);
  --shadow-sm: 0 2px 5px 0 var(--shadow-color);
  --shadow-md: 0 0px 10px 0 var(--shadow-color);
  --shadow-md-top: 0 -5px 10px 5px var(--shadow-color);
  --accent: \$primary-color !important;
  --primary: \$primary-color!important;
  --series-a: \$primary-color !important;
  --primary-0:#ebf7ff;
  --primary-0-rgb:235, 247, 255;
  --primary-50:#a9d3ef;
  --primary-100:#6fb2de;
  --primary-100-rgb:111, 178, 222;
  --primary-200:#4093cd;
  --primary-300:#1c74ba;
  --primary-300-rgb:28, 116, 186;
  --primary-400:#0255A5;
  --primary-500:#0046aa;
  --primary-600:#0b399c;
  --primary-700:#102669;
  --primary-800:#08112d;
  --primary-900:#070a16;
  --white:#ffffff;
  --white-rgb:255, 255, 255;
  --surface-0: #fefefe;
  --surface-50: #d7dfe5;
  --surface-50-rgb:215, 223, 229;
  --surface-100: #bac4cb;
  --surface-100-rgb:186, 196, 203;
  --surface-200: #9ea8b1;
  --surface-200-rgb:158, 168, 177;
  --surface-300: #828b97;
  --surface-400: #666f7d;
  --surface-500: #4B5363;
  --surface-500-rgb:75, 83, 99;
  --surface-600: #373d4f;
  --surface-700: #25283a;
  --surface-700-rgb:37, 40, 58;
  --surface-800: #151726;
  --surface-800-rgb:21, 23, 38;
  --surface-900: #090912;
  --size-0: 2px;
  --size-50: 4px;
  --size-100: 6px;
  --size-200: 8px;
  --size-300: 10px;
  --size-400: 16px;
  --size-500: 32px;
  --size-600: 48px;
  --size-700: 54px;
  --size-800: 70px;
  --size-900: 86px;
  --media-tablet-pro: 992px;
  --media-tablet: var(--media-tablet-pro);
  --media-mobile: 480px;
  --media-min: 0px;
  --priority-pm:var(--primary-color);
  --priority-high:var(--alert-danger);
  --priority-hot-parts: #059ea5;
  --priority-warranty: #e035bf;
  --priority-overtime-approval:var(--alert-warning);
  --priority-normal:var(--alert-success);
  --priority-special-equipment:#675081;
  --priority-locked-scheduled:var(--secondary-font-color);
}
:root .zuggit-base {
  --primary-color: #323283;
  --primary-0: #f2f4ff;
  --primary-0-rgb:242, 244, 255;
  --primary-50: #c4c5f2;
  --primary-100: #9b9be6;
  --primary-100-rgb:155, 155, 230;
  --primary-200: #7b7cd9;
  --primary-300: #5a5acb;
  --primary-300-rgb:90, 90, 203;
  --primary-400: #323283;
  --primary-500: #2a2a95;
  --primary-600: #242484;
  --primary-700: #1d1d63;
  --primary-800: #141441;
  --primary-900: #0c0c22;
  --surface-0: #fbfaff;
  --surface-50: #dcd9e4;
  --surface-50-rgb:220, 217, 228;
  --surface-100: #c1beca;
  --surface-100-rgb:193, 190, 202;
  --surface-200: #a6a3b1;
  --surface-200-rgb:166, 163, 177;
  --surface-300: #8b8798;
  --surface-400: #716c80;
  --surface-500: #585166;
  --surface-500-rgb:88, 81, 102;
  --surface-600: #423b4f;
  --surface-700: #2e2938;
  --surface-700-rgb:46, 41, 56;
  --surface-800: #1c1824;
  --surface-800-rgb:28, 24, 36;
  --surface-900: #0d0a12;
}

.m-0 {
  margin: 0;
}
.m-1 {
  margin: var(--size-100);
}
.m-2 {
  margin: var(--size-200);
}
.m-3 {
  margin: var(--size-300);
}
.m-4 {
  margin: var(--size-400);
}
.m-5 {
  margin: var(--size-500);
}
.m-6 {
  margin: var(--size-600);
}
.m-7 {
  margin: var(--size-700);
}
.m-8 {
  margin: var(--size-800);
}
.m-9 {
  margin: var(--size-900);
}
.mt-0 {
  margin-top: 0;
}
.mt-1 {
  margin-top: var(--size-100);
}
.mt-2 {
  margin-top: var(--size-200);
}
.mt-3 {
  margin-top: var(--size-300);
}
.mt-4 {
  margin-top: var(--size-400);
}
.mt-5 {
  margin-top: var(--size-500);
}
.mt-6 {
  margin-top: var(--size-600);
}
.mt-7 {
  margin-top: var(--size-700);
}
.mt-8 {
  margin-top: var(--size-800);
}
.mt-9 {
  margin-top: var(--size-900);
}
.mr-0 {
  margin-right: 0;
}
.mr-1 {
  margin-right: var(--size-100);
}
.mr-2 {
  margin-right: var(--size-200);
}
.mr-3 {
  margin-right: var(--size-300);
}
.mr-4 {
  margin-right: var(--size-400);
}
.mr-5 {
  margin-right: var(--size-500);
}
.mr-6 {
  margin-right: var(--size-600);
}
.mr-7 {
  margin-right: var(--size-700);
}
.mr-8 {
  margin-right: var(--size-800);
}
.mr-9 {
  margin-right: var(--size-900);
}
.mb-0 {
  margin-bottom: 0;
}
.mb-1 {
  margin-bottom: var(--size-100);
}
.mb-2 {
  margin-bottom: var(--size-200);
}
.mb-3 {
  margin-bottom: var(--size-300);
}
.mb-4 {
  margin-bottom: var(--size-400);
}
.mb-5 {
  margin-bottom: var(--size-500);
}
.mb-6 {
  margin-bottom: var(--size-600);
}
.mb-7 {
  margin-bottom: var(--size-700);
}
.mb-8 {
  margin-bottom: var(--size-800);
}
.mb-9 {
  margin-bottom: var(--size-900);
}
.ml-0 {
  margin-left: 0;
}
.ml-1 {
  margin-left: var(--size-100);
}
.ml-2 {
  margin-left: var(--size-200);
}
.ml-3 {
  margin-left: var(--size-300);
}
.ml-4 {
  margin-left: var(--size-400);
}
.ml-5 {
  margin-left: var(--size-500);
}
.ml-6 {
  margin-left: var(--size-600);
}
.ml-7 {
  margin-left: var(--size-700);
}
.ml-8 {
  margin-left: var(--size-800);
}
.ml-9 {
  margin-left: var(--size-900);
}

.p-0 {
  padding: 0;
}
.p-1 {
  padding: var(--size-100);
}
.p-2 {
  padding: var(--size-200);
}
.p-3 {
  padding: var(--size-300);
}
.p-4 {
  padding: var(--size-400);
}
.p-5 {
  padding: var(--size-500);
}
.p-6 {
  padding: var(--size-600);
}
.p-7 {
  padding: var(--size-700);
}
.p-8 {
  padding: var(--size-800);
}
.p-9 {
  padding: var(--size-900);
}
.pt-0 {
  padding-top: 0;
}
.pt-1 {
  padding-top: var(--size-100);
}
.pt-2 {
  padding-top: var(--size-200);
}
.pt-3 {
  padding-top: var(--size-300);
}
.pt-4 {
  padding-top: var(--size-400);
}
.pt-5 {
  padding-top: var(--size-500);
}
.pt-6 {
  padding-top: var(--size-600);
}
.pt-7 {
  padding-top: var(--size-700);
}
.pt-8 {
  padding-top: var(--size-800);
}
.pt-9 {
  padding-top: var(--size-900);
}
.pr-0 {
  padding-right: 0;
}
.pr-1 {
  padding-right: var(--size-100);
}
.pr-2 {
  padding-right: var(--size-200);
}
.pr-3 {
  padding-right: var(--size-300);
}
.pr-4 {
  padding-right: var(--size-400);
}
.pr-5 {
  padding-right: var(--size-500);
}
.pr-6 {
  padding-right: var(--size-600);
}
.pr-7 {
  padding-right: var(--size-700);
}
.pr-8 {
  padding-right: var(--size-800);
}
.pr-9 {
  padding-right: var(--size-900);
}
.pb-0 {
  padding-bottom: 0;
}
.pb-1 {
  padding-bottom: var(--size-100);
}
.pb-2 {
  padding-bottom: var(--size-200);
}
.pb-3 {
  padding-bottom: var(--size-300);
}
.pb-4 {
  padding-bottom: var(--size-400);
}
.pb-5 {
  padding-bottom: var(--size-500);
}
.pb-6 {
  padding-bottom: var(--size-600);
}
.pb-7 {
  padding-bottom: var(--size-700);
}
.pb-8 {
  padding-bottom: var(--size-800);
}
.pb-9 {
  padding-bottom: var(--size-900);
}
.pl-0 {
  padding-left: 0;
}
.pl-1 {
  padding-left: var(--size-100);
}
.pl-2 {
  padding-left: var(--size-200);
}
.pl-3 {
  padding-left: var(--size-300);
}
.pl-4 {
  padding-left: var(--size-400);
}
.pl-5 {
  padding-left: var(--size-500);
}
.pl-6 {
  padding-left: var(--size-600);
}
.pl-7 {
  padding-left: var(--size-700);
}
.pl-8 {
  padding-left: var(--size-800);
}
.pl-9 {
  padding-left: var(--size-900);
}

/*%pageTitleFont{
    font-size:\$pageTitleSize;
    font-weight:800;
}
%sectionTitleFont{
    font-size:var(--sectionTitleSize);
    font-weight:800;
}
%sectionSubTitleFont{
    font-size:var(--sectionSubTitleSize);
    font-weight:400;
}*/
/* chart 
buttons
date input
dialogs
dropdowns
iputs
grid
label
layout
tab strip
bound bar
menues
popup
scroll view
toolbar
tool tip
editor */
.partImage {
  height: 220px;
  margin-bottom: 10px;
  position: relative;
}
.partImage .newPhotoSmallBtn {
  position: absolute;
  top: 0;
  right: 13px;
}
.partImage .noImage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: var(--border-style);
  margin: 0 auto;
  width: 100%;
  height: 100%;
  color: var(--disabled-font-color);
}
.partImage .noImage i {
  font-size: 24px;
}
.partImage .noImage span {
  background-color: transparent;
  width: 100%;
  font-size: 14px;
}
.partImage .k-scrollview .k-scrollview-elements .k-scrollview-next, .partImage .k-scrollview .k-scrollview-elements .k-scrollview-prev {
  height: 100% !important;
  top: 0px !important;
}

.gridWrap {
  margin-top: 10px;
}
.gridWrap h2 {
  font-size: 16px;
}

.flex {
  display: flex;
  flex-flow: row wrap;
}
.flex .col {
  margin: 0 12px;
  width: calc(14.2857142857% - 24px);
}

.scrollViewWrap {
  height: 100%;
}

.mergeParts {
  padding: 30px;
  display: flex;
  flex-direction: column;
}
.mergeParts .instructions h1 {
  margin: 0 0 15px 0;
}
.mergeParts .info {
  border: 1px solid var(--alert-info);
  border-radius: var(--border-lg-radius);
  background-color: var(--alert-info-opacity);
  padding: 15px 30px;
  list-style: inside;
}
.mergeParts .info li {
  margin: 5px 0;
}
.mergeParts .info.error {
  border: 1px solid var(--alert-danger);
  background-color: var(--alert-danger-opacity);
}
.mergeParts .info.error i {
  color: var(--alert-danger);
  margin-right: 20px;
}
.mergeParts .mergeWrap {
  display: flex;
  margin: 15px 0;
}
.mergeParts .mergeWrap .merge {
  flex-grow: 2;
  display: flex;
  flex-flow: column;
  position: relative;
}
.mergeParts .mergeWrap .merge h3 {
  width: 100%;
  margin: 0;
}
.mergeParts .mergeWrap .merge {
  max-width: 50%;
}
.mergeParts .mergeWrap .merge .changePart {
  position: absolute;
  top: 0;
  right: 0;
}
.mergeParts .mergeWrap .merge .choosePart {
  flex-grow: 2;
  width: 100%;
  border: var(--border-style);
  display: flex;
  flex-flow: column;
  border-radius: var(--border-lg-radius);
  margin: 15px 0;
  background-color: var(--white);
  text-align: center;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: var(--primary-font-color);
}
.mergeParts .mergeWrap .merge .choosePart i {
  font-size: 60px;
  margin-bottom: 10px;
}
.mergeParts .mergeWrap .mergeIcon {
  flex-grow: 1;
  width: 100%;
  min-width: 40px;
  max-width: 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (min-width: var(--media-min)) and (max-width: var(--media-mobile)) {
  .mergeParts .mergeWrap {
    flex-flow: column;
  }
  .mergeParts .mergeWrap .merge {
    width: 100%;
  }
  .mergeParts .mergeWrap .mergeIcon {
    width: 100%;
    transform: rotate(90deg);
    margin: 30px 0;
  }
}
.mergeParts .partWrap {
  width: 100%;
  height: 100%;
  border: var(--border-style);
  display: flex;
  flex-flow: column;
  border-radius: var(--border-lg-radius);
  margin: 15px 0;
  background-color: var(--light-grey);
}
.mergeParts .partWrap.error {
  border-color: var(--alert-danger);
}
.mergeParts .partWrap .top {
  background-color: var(--white);
  border-bottom: var(--border-style);
  padding: 15px;
  display: flex;
  flex-flow: row wrap;
  border-radius: var(--border-lg-radius) var(--border-lg-radius) 0 0;
}
.mergeParts .partWrap .top .thumbnailImg {
  position: relative;
  min-height: 50px;
  min-width: 50px;
  height: 50px;
  width: 50px;
  margin: 0 20px 10px 0;
  overflow: hidden;
  border-radius: var(--border-m-radius);
  background-color: var(--light-grey);
  box-shadow: inset 0px 0px 0px 1px var(--surface-100);
}
.mergeParts .partWrap .top .thumbnailImg img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: transparent;
}
.mergeParts .partWrap .top .thumbnailImg .placeholder {
  width: 100%;
  height: 100%;
  text-align: center;
  content: "\\f03e";
  font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  font-weight: 900;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--disabled-font-color);
}
.mergeParts .partWrap .top .partTitle {
  display: flex;
  flex-flow: column;
}
.mergeParts .partWrap .top .partTitle .name {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 5px;
  color: var(--primary-font-color);
}
.mergeParts .partWrap .top .partTitle .number {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--primary-font-color);
}
.mergeParts .partWrap .top .description {
  font-size: 14px;
  font-weight: 500;
  color: var(--secondary-font-color);
  width: 100%;
}
.mergeParts .partWrap .bottom {
  background-color: var(--light-grey);
  padding: 15px;
  display: flex;
  flex-flow: column;
  border-radius: 0 0 var(--border-lg-radius) var(--border-lg-radius);
  height: auto;
}
.mergeParts .partWrap .bottom .pricing {
  font-width: 800;
  width: 100%;
  margin-bottom: 10px;
}
.mergeParts .partWrap .bottom .cp-input-container .noInput {
  padding: 5px 0 5px 5px;
}
.mergeParts .partWrap .changePart {
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  border-radius: 0 0 var(--border-lg-radius) var(--border-lg-radius);
  color: var(--primary-font-color);
  transition-duration: 0.1s;
  min-height: 30px;
  max-height: 32px;
  border-width: 1px 0 0 0;
  border-style: soild;
  border-color: var(--border-color);
  background-color: var(--light-grey);
}

.costDetails {
  display: flex;
  flex-direction: column;
  padding: 15px;
}
.costDetails .cost {
  padding: 5px 0;
}
.costDetails .cost h1 {
  font-size: 14px;
  font-style: bold;
  font-weight: 800;
  letter-spacing: 0px;
  font-family: var(--font);
  line-height: 1;
  color: var(--primary-font-color);
}
.costDetails .cost p {
  font-size: 12px;
  padding: 5px 0;
  font-family: var(--font);
  color: var(--primary-font-color);
  margin: 0;
}

/*.image-wrap{
    width:100%;
    margin:15px 0 15px 0;
    .image{
        width:100%;
        img{
            width:100%;
            height:auto;
        }
    }
}*/
/*.has-secondary-tabs .cp-no-padding .k-content{
    padding:0px;
}*/
/*.mat-expansion-panel{
    // margin:30px;
    background-color:#ffffff;
    .cp-primary-tabs .k-content{
        border: 0px;
    }
}*/
/*.demo-title {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0;
    padding: 15px;
    color: #fff;
    background-color: rgba(0,0,0,.4);
    text-align: center;
    font-size: 24px;
}*/
/*.dqoi-accordion{
    margin-bottom:30px;
    .dqoi-expansion-panel{
        margin-bottom:0px !important;
        border-bottom-width: 0px !important;
        .dqoi-logo{
            min-height:40px;
            min-width:40px;
            height:40px;
            width:40px;
            overflow: hidden;
            margin-left: 30px;
            border-radius:var(--border-m-radius);
            img{height:40px;}
            .no-logo{
                background-color: var(--light-grey);
                box-shadow: inset 0px 0px 0px 1px var(--border-color);
            }
        }
        .dqoi-panel-customer-info{
            max-width:326px;
            width:100%;
            display:flex;
            flex-direction: column;
            flex-wrap: nowrap;
            padding-right:20px;
            margin: 0px 13px 0px 20px;
            border-right:var(--border-style);
            #customer-name{
                font-size: 14px;
                font-weight: 700;
                max-width: 326px;
                height: 20px;
                line-height: 20px;
                color:var(--primary-font-color);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            #customer-location{
                font-size:12px;
                font-weight:400;
                max-width: 326px;
                height:20px;
                line-height:20px;
                color:var(--primary-font-color);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        .dqoi-panel-dqoi-info-wrap {
            display: flex;
            flex-flow: row wrap;
            width: 100%;
            .dqoi-panel-dqoi-info {
                flex-grow:1;
                margin: 0px 13px;
                max-width: 150px;
                .dqoi-label {
                    font-weight: 500;
                    font-size: 10px;
                    width: 100%;
                    height: 18px;
                    line-height: 18px;

                    .dqoi-panel-priority {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        line-height: 18px;
                        top: -13px;
                        position: relative;
                        left: 50px;
                    }
                }

                .dqoi-info {
                    font-color:var(--primary-font-color);
                    font-weight: 500;
                    font-size: 10px;
                    width: 100%;
                    height: 20px;
                    line-height: 20px;
                    span{
                        &:first-child{
                            margin-right:10px;
                            font-weight: 600;
                        }
                    }
                }
            }
        }
        .mat-expansion-panel-body{
            padding:0px !important;
        }
        .mat-expansion-panel-header-title{
            width:95%;
            display: flex;
        }
        .dqoi-panel-controls{
            display: flex;
            flex-flow: row nowrap;
            cp-loader{
                margin-right: 20px;
            }
        }
    }
}*/
/*.control-bar{
    width:100%;
    display: flex;
    flex-flow: row wrap;
    padding:0px 0px;
    //margin:-10px 0px 0px;
    margin:0px 20px 0px;
    .tab-type{
        flex-grow:2;
        display: flex;
        flex-flow: row nowrap;
        button{margin-right:10px;}
        h1{
            font-size:16px;
            font-weight:800;
        }
    }
    .control-btns {
        flex-grow:1;
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        justify-content: flex-end;
        .btn-wrap {
            margin: 0px 10px;
        }
        .separator {
            width: 1px;
            height: 30px;
            background-color: var(--border-color);
            margin: 0px 10px;
        }
        .edit-save-btn {
            width: 130px;
            margin: 0px 0px 0px 10px;

            button {
                width: 100%;
            }

            span {
                button {
                    width: calc(50% - 10px);
                }

                &:first-child {
                    margin-right: 10px;
                }

                &:last-child {
                    margiht-left: 10px;
                }
            }
        }
    }
}*/
.featured-box-wrap {
  display: flex;
  flex-flow: row wrap;
  padding: 13px 0px 0px;
  margin: 10px 0;
  border-radius: var(--border-m-radius);
}
.featured-box-wrap .featured-box {
  width: 100%;
  border: var(--border-style);
  background-color: var(--light-grey);
  padding: 13px;
}
.featured-box-wrap .featured-box h1 {
  font-size: 14px;
  font-weight: 900;
  color: var(--secondary-font-color);
  margin: 0;
}
.featured-box-wrap .featured-box {
  /*&.last-update{
      .cp-input-container{
          margin:10px 0 0;
          p{
              margin:0;
          }
      }
  }*/
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/cp-variables.scss","webpack://./src/app/cp/inventory/parts/parts.component.scss"],"names":[],"mappings":"AAIA;EACI,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,8CAAA;EACA,oBAAA;EACA,8BAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,wBAAA;EACA,wBAAA;EACA,oBAAA;EACA,gBAAA;EACA,yBAAA;EACA,gDAAA;EACA,kDAAA;EAIA,wCAAA;EACA,gDAAA;EACA,0CAAA;EACA,6BAAA;EACA,qCAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;EACA,0CAAA;EACA,6BAAA;EACA,4CAAA;EAGA,kCAAA;EACA,gDAAA;EACA,4BAAA;EACA,wDAAA;EACA,4CAAA;EACA,sBAAA;EACA,qBAAA;EACA,qCAAA;EACA,wCAAA;EACA,sBAAA;EACA,mCAAA;EAGA,uBAAA;EACA,qBAAA;EAEA,wCAAA;EAGA,uBAAA;EACA,gCAAA;EACA,iDAAA;EACA,uBAAA;EACA,+BAAA;EACA,gDAAA;EACA,kCAAA;EACA,0CAAA;EACA,4CAAA;EACA,sBAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,iCAAA;EACA,8BAAA;EACA,+BAAA;EACA,iCAAA;EAGA,oCAAA;EACA,4CAAA;EACA,6CAAA;EACA,oDAAA;EAIA,mCAAA;EACA,mCAAA;EACA,qCAAA;EAGA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,+BAAA;EACA,qBAAA;EACA,qBAAA;EACA,8BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EAEA,eAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EAEA,aAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAIA,yBAAA;EACA,uCAAA;EACA,qBAAA;EACA,gBAAA;EAGA,kCAAA;EACA,mCAAA;EACA,6BAAA;EACA,4BAAA;EACA,iDAAA;EACA,sCAAA;EACA,oCAAA;EACA,uDAAA;AC3BJ;AD6BI;EACI,wBAAA;EAEA,oBAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,+BAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;AC7BR;;ADsCI;EAAI,SAAA;AClCR;ADmCI;EAAI,uBAAA;AChCR;ADiCI;EAAI,uBAAA;AC9BR;AD+BI;EAAI,uBAAA;AC5BR;AD6BI;EAAI,uBAAA;AC1BR;AD2BI;EAAI,uBAAA;ACxBR;ADyBI;EAAI,uBAAA;ACtBR;ADuBI;EAAI,uBAAA;ACpBR;ADqBI;EAAI,uBAAA;AClBR;ADmBI;EAAI,uBAAA;AChBR;ADkBQ;EAAI,aAAA;ACfZ;ADgBQ;EAAI,2BAAA;ACbZ;ADcQ;EAAI,2BAAA;ACXZ;ADYQ;EAAI,2BAAA;ACTZ;ADUQ;EAAI,2BAAA;ACPZ;ADQQ;EAAI,2BAAA;ACLZ;ADMQ;EAAI,2BAAA;ACHZ;ADIQ;EAAI,2BAAA;ACDZ;ADEQ;EAAI,2BAAA;ACCZ;ADAQ;EAAI,2BAAA;ACGZ;ADAQ;EAAI,eAAA;ACGZ;ADFQ;EAAI,6BAAA;ACKZ;ADJQ;EAAI,6BAAA;ACOZ;ADNQ;EAAI,6BAAA;ACSZ;ADRQ;EAAI,6BAAA;ACWZ;ADVQ;EAAI,6BAAA;ACaZ;ADZQ;EAAI,6BAAA;ACeZ;ADdQ;EAAI,6BAAA;ACiBZ;ADhBQ;EAAI,6BAAA;ACmBZ;ADlBQ;EAAI,6BAAA;ACqBZ;ADlBQ;EAAI,gBAAA;ACqBZ;ADpBQ;EAAI,8BAAA;ACuBZ;ADtBQ;EAAI,8BAAA;ACyBZ;ADxBQ;EAAI,8BAAA;AC2BZ;AD1BQ;EAAI,8BAAA;AC6BZ;AD5BQ;EAAI,8BAAA;AC+BZ;AD9BQ;EAAI,8BAAA;ACiCZ;ADhCQ;EAAI,8BAAA;ACmCZ;ADlCQ;EAAI,8BAAA;ACqCZ;ADpCQ;EAAI,8BAAA;ACuCZ;ADpCI;EAAI,cAAA;ACuCR;ADtCI;EAAI,4BAAA;ACyCR;ADxCI;EAAI,4BAAA;AC2CR;AD1CI;EAAI,4BAAA;AC6CR;AD5CI;EAAI,4BAAA;AC+CR;AD9CI;EAAI,4BAAA;ACiDR;ADhDI;EAAI,4BAAA;ACmDR;ADlDI;EAAI,4BAAA;ACqDR;ADpDI;EAAI,4BAAA;ACuDR;ADtDI;EAAI,4BAAA;ACyDR;;ADrDI;EAAI,UAAA;ACyDR;ADxDI;EAAI,wBAAA;AC2DR;AD1DI;EAAI,wBAAA;AC6DR;AD5DI;EAAI,wBAAA;AC+DR;AD9DI;EAAI,wBAAA;ACiER;ADhEI;EAAI,wBAAA;ACmER;ADlEI;EAAI,wBAAA;ACqER;ADpEI;EAAI,wBAAA;ACuER;ADtEI;EAAI,wBAAA;ACyER;ADxEI;EAAI,wBAAA;AC2ER;ADzEQ;EAAI,cAAA;AC4EZ;AD3EQ;EAAI,4BAAA;AC8EZ;AD7EQ;EAAI,4BAAA;ACgFZ;AD/EQ;EAAI,4BAAA;ACkFZ;ADjFQ;EAAI,4BAAA;ACoFZ;ADnFQ;EAAI,4BAAA;ACsFZ;ADrFQ;EAAI,4BAAA;ACwFZ;ADvFQ;EAAI,4BAAA;AC0FZ;ADzFQ;EAAI,4BAAA;AC4FZ;AD3FQ;EAAI,4BAAA;AC8FZ;AD3FQ;EAAI,gBAAA;AC8FZ;AD7FQ;EAAI,8BAAA;ACgGZ;AD/FQ;EAAI,8BAAA;ACkGZ;ADjGQ;EAAI,8BAAA;ACoGZ;ADnGQ;EAAI,8BAAA;ACsGZ;ADrGQ;EAAI,8BAAA;ACwGZ;ADvGQ;EAAI,8BAAA;AC0GZ;ADzGQ;EAAI,8BAAA;AC4GZ;AD3GQ;EAAI,8BAAA;AC8GZ;AD7GQ;EAAI,8BAAA;ACgHZ;AD7GQ;EAAI,iBAAA;ACgHZ;AD/GQ;EAAI,+BAAA;ACkHZ;ADjHQ;EAAI,+BAAA;ACoHZ;ADnHQ;EAAI,+BAAA;ACsHZ;ADrHQ;EAAI,+BAAA;ACwHZ;ADvHQ;EAAI,+BAAA;AC0HZ;ADzHQ;EAAI,+BAAA;AC4HZ;AD3HQ;EAAI,+BAAA;AC8HZ;AD7HQ;EAAI,+BAAA;ACgIZ;AD/HQ;EAAI,+BAAA;ACkIZ;AD/HQ;EAAI,eAAA;ACkIZ;ADjIQ;EAAI,6BAAA;ACoIZ;ADnIQ;EAAI,6BAAA;ACsIZ;ADrIQ;EAAI,6BAAA;ACwIZ;ADvIQ;EAAI,6BAAA;AC0IZ;ADzIQ;EAAI,6BAAA;AC4IZ;AD3IQ;EAAI,6BAAA;AC8IZ;AD7IQ;EAAI,6BAAA;ACgJZ;AD/IQ;EAAI,6BAAA;ACkJZ;ADjJQ;EAAI,6BAAA;ACoJZ;;ADkBA;;;;;;;;;;;EAAA;AAoCA;;;;;;;;;;;;;;;;QAAA;ACtgBA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAgfJ;AA/eI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;AAifR;AA/eI;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;AAifR;AAhfQ;EACI,eAAA;AAkfZ;AAhfQ;EACI,6BAAA;EACA,WAAA;EACA,eAAA;AAkfZ;AA/eI;EACI,uBAAA;EACA,mBAAA;AAifR;;AA9eA;EACI,gBAAA;AAifJ;AAhfI;EAAG,eAAA;AAmfP;;AAhfA;EACI,aAAA;EACA,mBAAA;AAmfJ;AAlfI;EACI,cAAA;EACA,kCAAA;AAofR;;AAjfA;EACI,YAAA;AAofJ;;AAhfA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;AAmfJ;AAjfQ;EACI,kBAAA;AAmfZ;AAhfI;EACI,mCAAA;EACA,sCAAA;EACA,2CAAA;EACA,kBAAA;EACA,kBAAA;AAkfR;AAjfQ;EACI,aAAA;AAmfZ;AAjfQ;EACI,qCAAA;EACA,6CAAA;AAmfZ;AAlfY;EACI,0BAAA;EACA,kBAAA;AAofhB;AA/eI;EACI,aAAA;EAEA,cAAA;AAgfR;AA/eQ;EACI,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;AAifZ;AAhfY;EACI,WAAA;EACA,SAAA;AAkfhB;AAzfQ;EASI,cAAA;AAmfZ;AAlfY;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AAofhB;AAlfY;EACI,YAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,sCAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAofhB;AAnfgB;EACI,eAAA;EACA,mBAAA;AAqfpB;AAjfQ;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAkfZ;AAhfQ;EAnDJ;IAoDQ,iBAAA;EAmfV;EAlfU;IACI,WAAA;EAofd;EAlfU;IACI,WAAA;IACA,wBAAA;IACA,cAAA;EAofd;AACF;AAhfI;EACI,WAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,sCAAA;EACA,cAAA;EACA,mCAAA;AAkfR;AAjfQ;EAAQ,iCAAA;AAofhB;AAnfQ;EACI,8BAAA;EACA,kCAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,kEAAA;AAqfZ;AApfY;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,qCAAA;EACA,mCAAA;EACA,oDAAA;AAsfhB;AArfgB;EACI,WAAA;EACA,YAAA;EAEA,mBAAA;EACA,6BAAA;AAufpB;AArfgB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iCAAA;AAufpB;AApfY;EACI,aAAA;EACA,iBAAA;AAsfhB;AApfgB;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,gCAAA;AAsfpB;AApfgB;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AAsfpB;AAnfY;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,WAAA;AAqfhB;AAlfQ;EACI,mCAAA;EACA,aAAA;EACA,aAAA;EACA,iBAAA;EACA,kEAAA;EACA,YAAA;AAofZ;AAnfY;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AAqfhB;AAnfY;EAA6B,sBAAA;AAsfzC;AApfQ;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kEAAA;EACA,gCAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mCAAA;AAsfZ;;AAjfA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AAofJ;AAnfI;EACI,cAAA;AAqfR;AApfQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;EACA,cAAA;EACA,gCAAA;AAsfZ;AApfQ;EACI,eAAA;EACA,cAAA;EACA,wBAAA;EACA,gCAAA;EACA,SAAA;AAsfZ;;AAhfA;;;;;;;;;;EAAA;AAYA;;EAAA;AAIA;;;;;;EAAA;AASA;;;;;;;;;;;EAAA;AAcA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AA8GA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAAA;AAyDA;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,qCAAA;AA2eJ;AA1eI;EACI,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,aAAA;AA4eR;AA1eQ;EACI,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;AA4eZ;AAtfI;EAYI;;;;;;;IAAA;AAofR","sourcesContent":["@use \"sass:map\";\n@use \"sass:color\";\n@use \"sass:math\";\n\n:root{\n    --primary-color: #0255A5;\n    --primary-color-rgb:2, 85, 165; // For RGBA methods - Make sure to match value with hex code\n    --primary-color-hover:#0F3B66;\n    --primary-color-opacity: rgba(2, 85, 165, 0.1);\n    --light-grey:#F9F9F9;\n    --light-grey-rgb:249, 249, 249; // For RGBA methods - Make sure to match value with hex code\n    --dark-grey:#9A9C9F;\n    --dark-grey-rgb:154, 156, 159; // For RGBA methods - Make sure to match value with hex code\n    --darkGrey:#1b232c;\n    --hover-bg-color:#E4E8EF;\n    --white-bg-hover:#e8eff2;\n    --light-blue:#6A80A9;\n    --purple:#675081;\n    --purple-rgb:103, 80, 129;// For RGBA methods - Make sure to match value with hex code\n    --textHighlightBgColor:rgba(191, 219, 253, 0.90);\n    --textHighlightFontColor:var(--primary-font-color);\n\n\n    //Fonts\n    --primary-font-color: var(--surface-500);\n    --primary-font-color-rgb: var(--surface-500-rgb);\n    --secondary-font-color: var(--surface-700);\n    --disabled-font-color:#828b97;\n    --font:\"Open Sans\", Arial, sans-serif;\n    --h1:24px;\n    --h2:18px;\n    --h3:16px;\n    --h4:13px;\n    --bodyFontSize:14px;\n    --tableFontSize:12px;\n    --pageTitleSize:var(--h1);\n    --sectionTitleSize:var(--h2);\n    --sectionSubTitleSize:var(--tableFontSize);\n    --sectionTitleLabel:var(--h3);\n    --accordionTitleSize:var(--sectionTitleSize);\n\n    //Borders\n    --border-color: var(--surface-100);\n    --darkBorderColor: var(--textHighlightFontColor);\n    --table-border-color:#E8EFF2;\n    --table-border-style:1px solid var(--table-border-color);\n    --border-style:1px solid var(--border-color);\n    --border-lg-radius:8px;\n    --border-m-radius:4px;\n    --border-m-radius-top:4px 4px 0px 0px;\n    --border-m-radius-bottom:0px 0px 4px 4px;\n    --border-sm-radius:2px;\n    --border-radius-tab:2px 2px 0px 0px;\n\n    //Text highlight colors\n    --selected-text:#E4E8EF;\n    --selected-bg:#E4E8EF;\n\n    --table-alt-row-color: var(--light-grey);\n\n    // Alert & Notification Colors\n    --alert-warning:#D6BA17;\n    --alert-warning-rgb:214, 186, 23; // For RGBA methods - Make sure to match value with hex code\n    --alert-warning-opacity: rgba(214, 186, 23, 0.10);\n    --alert-success:#02a570;\n    --alert-success-rgb:2, 165, 112;\n    --alert-success-opacity: rgba(2, 165, 112, 0.10);\n    --alert-info: var(--primary-color);\n    --alert-info-rgb: var(--primary-color-rgb); // For RGBA methods - Make sure to match value with hex code\n    --alert-info-opacity: rgba(2, 85, 165, 0.11);\n    --alert-danger:#E02222;\n    --alert-danger-rgb:224, 34, 34;\n    --alert-danger-opacity: rgba(224, 34, 34, 0.10);\n    --alert-danger-hover: #871a1a;\n    --alert-medium:#F97031;\n    --alert-medium-rgb:249, 112, 49; // For RGBA methods - Make sure to match value with hex code\n    --brown:#5b4434;\n    --notification-warning-bg:#FAF8E7;\n    --notification-info-bg:#E5EEF6;\n    --notification-error-bg:#FBE8E8;\n    --notification-success-bg:#E5F6F0;\n\n    //Shadows\n    --shadow-color:rgba(89,101,118,0.32);\n    --shadow-sm: 0 2px 5px 0 var(--shadow-color);\n    --shadow-md: 0 0px 10px 0 var(--shadow-color);\n    --shadow-md-top: 0 -5px 10px 5px var(--shadow-color);\n\n\n    // Misc\n    --accent: $primary-color !important;\n    --primary: $primary-color!important;\n    --series-a: $primary-color !important;\n\n    // System Colors\n    --primary-0:#ebf7ff;\n    --primary-0-rgb:235, 247, 255; // For RGBA methods - Make sure to match value with hex code\n    --primary-50:#a9d3ef;\n    --primary-100:#6fb2de;\n    --primary-100-rgb:111, 178, 222; // For RGBA methods - Make sure to match value with hex code\n    --primary-200:#4093cd;\n    --primary-300:#1c74ba;\n    --primary-300-rgb:28, 116, 186; // For RGBA methods - Make sure to match value with hex code\n    --primary-400:#0255A5;\n    --primary-500:#0046aa;\n    --primary-600:#0b399c;\n    --primary-700:#102669;\n    --primary-800:#08112d;\n    --primary-900:#070a16;\n\n    --white:#ffffff;\n    --white-rgb:255, 255, 255; // For RGBA methods - Make sure to match value with hex code\n    --surface-0: #fefefe;\n    --surface-50: #d7dfe5;\n    --surface-50-rgb:215, 223, 229; // For RGBA methods - Make sure to match value with hex code\n    --surface-100: #bac4cb;\n    --surface-100-rgb:186, 196, 203; // For RGBA methods - Make sure to match value with hex code\n    --surface-200: #9ea8b1;\n    --surface-200-rgb:158, 168, 177; // For RGBA methods - Make sure to match value with hex code\n    --surface-300: #828b97;\n    --surface-400: #666f7d;\n    --surface-500: #4B5363;\n    --surface-500-rgb:75, 83, 99; // For RGBA methods - Make sure to match value with hex code\n    --surface-600: #373d4f;\n    --surface-700: #25283a;\n    --surface-700-rgb:37, 40, 58; // For RGBA methods - Make sure to match value with hex code\n    --surface-800: #151726;\n    --surface-800-rgb:21, 23, 38; // For RGBA methods - Make sure to match value with hex code\n    --surface-900: #090912;\n\n    --size-0: 2px;\n    --size-50: 4px;\n    --size-100: 6px;\n    --size-200: 8px;\n    --size-300: 10px;\n    --size-400: 16px;\n    --size-500: 32px;\n    --size-600: 48px;\n    --size-700: 54px;\n    --size-800: 70px;\n    --size-900: 86px;\n\n\n    //Media Queries\n    --media-tablet-pro: 992px;\n    --media-tablet: var(--media-tablet-pro);\n    --media-mobile: 480px;\n    --media-min: 0px;\n\n    // Priority Colors\n    --priority-pm:var(--primary-color);\n    --priority-high:var(--alert-danger);\n    --priority-hot-parts: #059ea5;\n    --priority-warranty: #e035bf;\n    --priority-overtime-approval:var(--alert-warning);\n    --priority-normal:var(--alert-success);\n    --priority-special-equipment:#675081;\n    --priority-locked-scheduled:var(--secondary-font-color);\n\n    .zuggit-base{\n        --primary-color: #323283;\n\n        --primary-0: #f2f4ff;\n        --primary-0-rgb:242, 244, 255; // For RGBA methods - Make sure to match value with hex code\n        --primary-50: #c4c5f2;\n        --primary-100: #9b9be6;\n        --primary-100-rgb:155, 155, 230; // For RGBA methods - Make sure to match value with hex code\n        --primary-200: #7b7cd9;\n        --primary-300: #5a5acb;\n        --primary-300-rgb:90, 90, 203; // For RGBA methods - Make sure to match value with hex code\n        --primary-400: #323283;\n        --primary-500: #2a2a95;\n        --primary-600: #242484;\n        --primary-700: #1d1d63;\n        --primary-800: #141441;\n        --primary-900: #0c0c22;\n\n        --surface-0: #fbfaff;\n        --surface-50: #dcd9e4;\n        --surface-50-rgb:220, 217, 228; // For RGBA methods - Make sure to match value with hex code\n        --surface-100: #c1beca;\n        --surface-100-rgb:193, 190, 202; // For RGBA methods - Make sure to match value with hex code\n        --surface-200: #a6a3b1;\n        --surface-200-rgb:166, 163, 177; // For RGBA methods - Make sure to match value with hex code\n        --surface-300: #8b8798;\n        --surface-400: #716c80;\n        --surface-500: #585166;\n        --surface-500-rgb:88, 81, 102; // For RGBA methods - Make sure to match value with hex code\n        --surface-600: #423b4f;\n        --surface-700: #2e2938;\n        --surface-700-rgb:46, 41, 56; // For RGBA methods - Make sure to match value with hex code\n        --surface-800: #1c1824;\n        --surface-800-rgb:28, 24, 36; // For RGBA methods - Make sure to match value with hex code\n        --surface-900: #0d0a12;\n\n\n\n    }\n\n}\n\n.m{\n    &-0{margin: 0;}\n    &-1{margin: var(--size-100);}\n    &-2{margin: var(--size-200);}\n    &-3{margin: var(--size-300);}\n    &-4{margin: var(--size-400);}\n    &-5{margin: var(--size-500);}\n    &-6{margin: var(--size-600);}\n    &-7{margin: var(--size-700);}\n    &-8{margin: var(--size-800);}\n    &-9{margin: var(--size-900);}\n    &t{\n        &-0{margin-top: 0;}\n        &-1{margin-top: var(--size-100);}\n        &-2{margin-top: var(--size-200);}\n        &-3{margin-top: var(--size-300);}\n        &-4{margin-top: var(--size-400);}\n        &-5{margin-top: var(--size-500);}\n        &-6{margin-top: var(--size-600);}\n        &-7{margin-top: var(--size-700);}\n        &-8{margin-top: var(--size-800);}\n        &-9{margin-top: var(--size-900);}\n    }\n    &r{\n        &-0{margin-right: 0;}\n        &-1{margin-right: var(--size-100);}\n        &-2{margin-right: var(--size-200);}\n        &-3{margin-right: var(--size-300);}\n        &-4{margin-right: var(--size-400);}\n        &-5{margin-right: var(--size-500);}\n        &-6{margin-right: var(--size-600);}\n        &-7{margin-right: var(--size-700);}\n        &-8{margin-right: var(--size-800);}\n        &-9{margin-right: var(--size-900);}\n    }\n    &b{\n        &-0{margin-bottom: 0;}\n        &-1{margin-bottom: var(--size-100);}\n        &-2{margin-bottom: var(--size-200);}\n        &-3{margin-bottom: var(--size-300);}\n        &-4{margin-bottom: var(--size-400);}\n        &-5{margin-bottom: var(--size-500);}\n        &-6{margin-bottom: var(--size-600);}\n        &-7{margin-bottom: var(--size-700);}\n        &-8{margin-bottom: var(--size-800);}\n        &-9{margin-bottom: var(--size-900);}\n    }\n    &l{\n    &-0{margin-left: 0;}\n    &-1{margin-left: var(--size-100);}\n    &-2{margin-left: var(--size-200);}\n    &-3{margin-left: var(--size-300);}\n    &-4{margin-left: var(--size-400);}\n    &-5{margin-left: var(--size-500);}\n    &-6{margin-left: var(--size-600);}\n    &-7{margin-left: var(--size-700);}\n    &-8{margin-left: var(--size-800);}\n    &-9{margin-left: var(--size-900);}\n    }\n}\n.p{\n    &-0{padding: 0;}\n    &-1{padding: var(--size-100);}\n    &-2{padding: var(--size-200);}\n    &-3{padding: var(--size-300);}\n    &-4{padding: var(--size-400);}\n    &-5{padding: var(--size-500);}\n    &-6{padding: var(--size-600);}\n    &-7{padding: var(--size-700);}\n    &-8{padding: var(--size-800);}\n    &-9{padding: var(--size-900);}\n    &t{\n        &-0{padding-top: 0;}\n        &-1{padding-top: var(--size-100);}\n        &-2{padding-top: var(--size-200);}\n        &-3{padding-top: var(--size-300);}\n        &-4{padding-top: var(--size-400);}\n        &-5{padding-top: var(--size-500);}\n        &-6{padding-top: var(--size-600);}\n        &-7{padding-top: var(--size-700);}\n        &-8{padding-top: var(--size-800);}\n        &-9{padding-top: var(--size-900);}\n    }\n    &r{\n        &-0{padding-right: 0;}\n        &-1{padding-right: var(--size-100);}\n        &-2{padding-right: var(--size-200);}\n        &-3{padding-right: var(--size-300);}\n        &-4{padding-right: var(--size-400);}\n        &-5{padding-right: var(--size-500);}\n        &-6{padding-right: var(--size-600);}\n        &-7{padding-right: var(--size-700);}\n        &-8{padding-right: var(--size-800);}\n        &-9{padding-right: var(--size-900);}\n    }\n    &b{\n        &-0{padding-bottom: 0;}\n        &-1{padding-bottom: var(--size-100);}\n        &-2{padding-bottom: var(--size-200);}\n        &-3{padding-bottom: var(--size-300);}\n        &-4{padding-bottom: var(--size-400);}\n        &-5{padding-bottom: var(--size-500);}\n        &-6{padding-bottom: var(--size-600);}\n        &-7{padding-bottom: var(--size-700);}\n        &-8{padding-bottom: var(--size-800);}\n        &-9{padding-bottom: var(--size-900);}\n    }\n    &l{\n        &-0{padding-left: 0;}\n        &-1{padding-left: var(--size-100);}\n        &-2{padding-left: var(--size-200);}\n        &-3{padding-left: var(--size-300);}\n        &-4{padding-left: var(--size-400);}\n        &-5{padding-left: var(--size-500);}\n        &-6{padding-left: var(--size-600);}\n        &-7{padding-left: var(--size-700);}\n        &-8{padding-left: var(--size-800);}\n        &-9{padding-left: var(--size-900);}\n    }\n}\n\n$primaryColor:#0255A5;\n$primaryFontColor:#4B5363;\n$white: #ffffff;\n\n//DarkMode\n$primaryDM: #2A2E3A;\n$primaryFontColorDM: #eeeeee;\n\n$colors: (\n        blue: (\n                base: $primaryColor,\n                0: #ebf7ff,\n                10: #a9d3ef,\n                20: #6fb2de,\n                30: #4093cd,\n                40: #1c74ba,\n                50: $primaryColor,\n                60: #0046aa,\n                70: #0b399c,\n                80: #102669,\n                90: #08112d,\n                100: #070a16,\n        ),\n        neutral: (\n                base: $primaryFontColor,\n                0: #fefefe,\n                10: #d7dfe5,\n                20: #bac4cb,\n                30: #9ea8b1,\n                40: #828b97,\n                50: #666f7d,\n                60: $primaryFontColor,\n                70: #373d4f,\n                80: #25283a,\n                90: #151726,\n                100: #090912,\n        ),\n        primary: (\n                base: $primaryColor,\n                light: color.scale($primaryColor, $lightness: 15%),\n                dark: color.scale($primaryColor, $blackness: 30%),\n                disabled: color.scale($primaryColor, $saturation: -90%, $lightness: 60%),\n                darkMode:$primaryDM,\n        ),\n        white: (\n                base:var(--white),\n                hover: color.scale($primaryColor, $lightness: 80%, $saturation: -82%),\n                dark: color.scale($white, $blackness: 30%),\n\n        ),\n        font:(\n                base: $primaryFontColor,\n                secondary: color.scale($primaryFontColor, $blackness: 30%),\n                disabled: color.scale($primaryFontColor, $saturation: -10%, $lightness: 20%),\n                darkMode:$primaryFontColorDM,\n        )\n);\n\n$shadow: 0 0px 10px 0 #151726;\n\n\n$fonts: (\n        \"Helvetica\": (\n                \"weights\": (\n                        \"regular\": 400,\n                        \"medium\": 500,\n                        \"bold\": 700\n                )\n        )\n);\n\n@function get-color($color, $shade: base) {\n    @return map.get(map.get($colors, $color), $shade);\n}\n\n\n\n\n///////////////////////////////////////////\n// DEPRECATED DO NOT USE THESE VARIABLES //\n///////////////////////////////////////////\n\n\n// Climate Pros Font Colors\n$primary-font-color:#1b232c; //\n$secondary-font-color:#4B5363;//\n$disabled-font-color:#8A939D;//\n$light-grey:#F9F9F9;//\n$dark-grey:#9A9C9F;//\n//var(--white):#ffffff;\n\n// Climate Pros Colors\n$primary-color:#0255A5;\n$primary-color-hover:#0F3B66;\n$primary-color-opacity:rgba(2, 85, 165, 0.1);\n$darkgrey:var(--secondary-font-color);\n$hover-bg-color:#E4E8EF;\n$white-bg-hover:#e8eff2;\n$light-blue:#6A80A9;\n$purple:#675081;\n$textHighlightBgColor:rgba(#BFDBFD, 0.90);\n$textHighlightFontColor:var(--secondary-font-color);\n\n\n// CP Borders\n//var(--border-color): #D5DDE2;\n$border-color: #bac4cb;\n$darkBorderColor: var(--textHighlightFontColor);\n$table-border-color:#E8EFF2;\n$table-border-style:1px solid var(--table-border-color);\n$border-style:1px solid var(--border-color);\n//var(--border-style):1px solid var(--border-color);var(--surface-0)\n$border-lg-radius:8px;\n$border-m-radius:4px;\n$border-m-radius-top:4px 4px 0px 0px;\n$border-m-radius-bottom:0px 0px 4px 4px;\n$border-sm-radius:2px;\n$border-radius-tab:2px 2px 0px 0px;\n\n$selected-text:#E4E8EF;\n$selected-bg:#E4E8EF;\n\n$table-alt:var(--light-grey);\n\n// Alert Colors\n$alert-warning:#D6BA17;\n$alert-warning-opacity: rgba(214, 186, 23, 0.10);\n$alert-success:#02a570;\n$alert-success-opacity: rgba(2, 165, 112, 0.10);\n$alert-info:var(--primary-color);\n$alert-info-opacity: rgba(2, 85, 165, 0.11);\n$alert-danger:#E02222;\n$alert-danger-opacity: rgba(224, 34, 34, 0.10);\n$alert-danger-hover: #871a1a;\n$alert-medium:#F97031;\n$brown:#5b4434;\n\n$notification-warning-bg:#FAF8E7;\n$notification-info-bg:#E5EEF6;\n$notification-error-bg:#FBE8E8;\n$notification-success-bg:#E5F6F0;\n\n\n//Shadows\n$shadow-color:rgba(89,101,118,0.32);\n$shadow-sm: 0 2px 5px 0 var(--shadow-color);\n$shadow-md: 0 0px 10px 0 var(--shadow-color);\n$shadow-md-top: 0 -5px 10px 5px var(--shadow-color);\n\n//Fonts\n$font:\"Open Sans\", Arial, sans-serif;\n$h1:24px;\n$h2:18px;\n$h3:16px;\n$h4:13px;\n$bodyFontSize:14px;\n$tableFontSize:12px;\n$pageTitleSize:var(--h1);\n$sectionTitleSize:var(--h2);\n$sectionSubTitleSize:var(--tableFontSize);\n$sectionTitleLabel:var(--h3);\n$accordionTitleSize:var(--sectionTitleSize);\n/*%pageTitleFont{\n    font-size:$pageTitleSize;\n    font-weight:800;\n}\n%sectionTitleFont{\n    font-size:var(--sectionTitleSize);\n    font-weight:800;\n}\n%sectionSubTitleFont{\n    font-size:var(--sectionSubTitleSize);\n    font-weight:400;\n}*/\n\n\n//Prioritys\n$priority-pm:var(--primary-color);\n$priority-high:var(--alert-danger);\n$priority-hot-parts: #059ea5;\n$priority-warranty: #e035bf;\n$priority-overtime-approval:var(--alert-warning);\n$priority-normal:var(--alert-success);\n$priority-special-equipment:#675081;\n$priority-locked-scheduled:var(--secondary-font-color);\n\n//Spacing\n$fullSpacing:30px;\n$halfSpacing:calc($fullSpacing/2);\n$quarterSpacing:calc($fullSpacing/4);\n\n\n//Media Queries\n$mediaTabletPro: 992px;\n$mediaTablet: $mediaTabletPro;\n$mediaMobile: 480px;\n$mediaMin: 0px;\n\n/* chart \nbuttons\ndate input\ndialogs\ndropdowns\niputs\ngrid\nlabel\nlayout\ntab strip\nbound bar\nmenues\npopup\nscroll view\ntoolbar\ntool tip\neditor */\n\n\n////////////////////\n//Dark Mode Colors//\n////////////////////\n$darkModeAppBg:#22252A;\n$darkModeBg1:#2A2E3A;\n$darkModeBg2:#2A2E36;\n$darkModeBg3:#15161a;\n$darkModeBorderColor:#484D5A;\n$darkModeOutlineBtnBg:#262A31;\n$darkModeInputBg:$darkModeBg1;\n$darkModePrimaryFontColor:#eeeeee;\n$darkModeSecondaryFontColor:var(--white);\n$darkModeDisabledFontColor:rgba($darkModePrimaryFontColor, .4);\n$darkModeDrawerBg:#15191d;\n\n\n\n\n// FUNCTIONS\n$browser-context: 16; // Default\n\n@function em($pixels, $context: $browser-context) {\n    @return #{$pixels/$context}em;\n}\n","@use \"./src/assets/scss/cp-variables.scss\" as *;\n\n.partImage{\n    height:220px;\n    margin-bottom:10px;\n    position:relative;\n    .newPhotoSmallBtn{\n        position:absolute;\n        top:0;\n        right:13px;\n    }\n    .noImage{\n        display:flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        text-align: center;\n        border:var(--border-style);\n        margin: 0 auto;\n        width:100%;\n        height:100%;\n        color:var(--disabled-font-color);\n        i{\n            font-size: 24px;\n        }\n        span{\n            background-color:transparent;\n            width:100%;\n            font-size:14px;\n        }\n    }\n    .k-scrollview .k-scrollview-elements .k-scrollview-next, .k-scrollview .k-scrollview-elements .k-scrollview-prev{\n        height:100% !important;\n        top:0px !important;\n    }\n}\n.gridWrap{\n    margin-top:10px;\n    h2{font-size:16px;}\n}\n\n.flex{\n    display: flex;\n    flex-flow: row wrap;\n    .col{\n        margin:0 12px;\n        width:calc(100% / 7 - 24px);\n    }\n}\n.scrollViewWrap{\n    height:100%;\n}\n\n\n.mergeParts{\n    padding:30px;\n    display:flex;\n    flex-direction: column;\n    .instructions{\n        h1{\n            margin:0 0 15px 0;\n        }\n    }\n    .info{\n        border:1px solid var(--alert-info);\n        border-radius: var(--border-lg-radius);\n        background-color:var(--alert-info-opacity);\n        padding: 15px 30px;\n        list-style: inside;\n        li{\n            margin:5px 0;\n        }\n        &.error{\n            border:1px solid var(--alert-danger);\n            background-color:var(--alert-danger-opacity);\n            i{\n                color:var(--alert-danger);\n                margin-right:20px;\n            }\n        }\n    }\n\n    .mergeWrap{\n        display: flex;\n        //flex-flow: row wrap;\n        margin: 15px 0;\n        .merge{\n            flex-grow:2;\n            display:flex;\n            flex-flow:column;\n            position:relative;\n            h3{\n                width:100%;\n                margin:0;\n            }\n            max-width: 50%;\n            .changePart{\n                position:absolute;\n                top:0;\n                right:0;\n            }\n            .choosePart{\n                flex-grow: 2;\n                width:100%;\n                border:var(--border-style);\n                display:flex;\n                flex-flow:column;\n                border-radius: var(--border-lg-radius);\n                margin:15px 0;\n                background-color:var(--white);\n                text-align: center;\n                align-items: center;\n                justify-content: center;\n                font-size: 16px;\n                font-weight: 700;\n                color: var(--primary-font-color);\n                i{\n                    font-size: 60px;\n                    margin-bottom: 10px;\n                }\n            }\n        }\n        .mergeIcon{\n            //width: calc(10% - 20px);\n            flex-grow:1;\n            width:100%;\n            min-width:40px;\n            max-width:60px;\n            text-align:center;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n        }\n        @media only screen and (min-width: var(--media-min)) and (max-width: var(--media-mobile)){\n            flex-flow: column;\n            .merge{\n                width: 100%;\n            }\n            .mergeIcon{\n                width: 100%;\n                transform: rotate(90deg);\n                margin: 30px 0;\n            }\n        }\n    }\n\n    .partWrap{\n        width:100%;\n        height: 100%;\n        border:var(--border-style);\n        display:flex;\n        flex-flow:column;\n        border-radius: var(--border-lg-radius);\n        margin:15px 0;\n        background-color:var(--light-grey);\n        &.error{border-color: var(--alert-danger);}\n        .top{\n            background-color:var(--white);\n            border-bottom:var(--border-style);\n            padding:15px;\n            display:flex;\n            flex-flow:row wrap;\n            border-radius: var(--border-lg-radius) var(--border-lg-radius) 0 0;\n            .thumbnailImg{\n                position:relative;\n                min-height: 50px;\n                min-width: 50px;\n                height: 50px;\n                width: 50px;\n                margin:0 20px 10px 0;\n                overflow: hidden;\n                border-radius: var(--border-m-radius);\n                background-color:var(--light-grey);\n                box-shadow: inset 0px 0px 0px 1px var(--surface-100);\n                img{\n                    width: 100%;\n                    height: 100%;\n                    -o-object-fit: contain;\n                    object-fit: contain;\n                    background-color: transparent;\n                }\n                .placeholder{\n                    width:100%;\n                    height:100%;\n                    text-align: center;\n                    content:\"\\f03e\";\n                    font-family: 'Font Awesome 5 Pro', 'Font Awesome 5 Free';\n                    font-weight:900;\n                    display: flex;\n                    flex-direction: column;\n                    justify-content: center;\n                    color:var(--disabled-font-color);\n                }\n            }\n            .partTitle{\n                display:flex;\n                flex-flow:column;\n                //width:100%;\n                .name{\n                    font-size:18px;\n                    font-weight:800;\n                    margin-bottom:5px;\n                    color:var(--primary-font-color);\n                }\n                .number{\n                    font-size:14px;\n                    font-weight:600;\n                    margin-bottom:10px;\n                    color:var(--primary-font-color);\n                }\n            }\n            .description{\n                font-size:14px;\n                font-weight:500;\n                color:var(--secondary-font-color);\n                width:100%;\n            }\n        }\n        .bottom{\n            background-color:var(--light-grey);\n            padding:15px;\n            display:flex;\n            flex-flow:column;\n            border-radius:0 0 var(--border-lg-radius) var(--border-lg-radius);\n            height: auto;\n            .pricing{\n                font-width:800;\n                width:100%;\n                margin-bottom:10px;\n            }\n            .cp-input-container .noInput{padding: 5px 0 5px 5px}\n        }\n        .changePart{\n            width:100%;\n            font-size:14px;\n            font-weight:400;\n            border-radius:0 0 var(--border-lg-radius) var(--border-lg-radius);\n            color:var(--primary-font-color);\n            transition-duration: 0.1s;\n            min-height:30px;\n            max-height: 32px;\n            border-width: 1px 0 0 0;\n            border-style: soild;\n            border-color:var(--border-color);\n            background-color:var(--light-grey);\n        }\n    }\n}\n\n.costDetails{\n    display:flex;\n    flex-direction: column;\n    padding:15px;\n    .cost{\n        padding:5px 0;\n        h1{\n            font-size: 14px;\n            font-style: bold;\n            font-weight:800;\n            letter-spacing: 0px;\n            font-family:var(--font);\n            line-height:1;\n            color:var(--primary-font-color);\n        }\n        p{\n            font-size: 12px;\n            padding:5px 0;\n            font-family:var(--font);\n            color:var(--primary-font-color);\n            margin: 0;\n        }\n    }\n}\n\n\n/*.image-wrap{\n    width:100%;\n    margin:15px 0 15px 0;\n    .image{\n        width:100%;\n        img{\n            width:100%;\n            height:auto;\n        }\n    }\n}*/\n\n/*.has-secondary-tabs .cp-no-padding .k-content{\n    padding:0px;\n}*/\n// Test example\n/*.mat-expansion-panel{\n    // margin:30px;\n    background-color:#ffffff;\n    .cp-primary-tabs .k-content{\n        border: 0px;\n    }\n}*/\n\n//For Photos TODO BW: Take a look\n/*.demo-title {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: 0;\n    padding: 15px;\n    color: #fff;\n    background-color: rgba(0,0,0,.4);\n    text-align: center;\n    font-size: 24px;\n}*/\n\n\n/*.dqoi-accordion{\n    margin-bottom:30px;\n    .dqoi-expansion-panel{\n        margin-bottom:0px !important;\n        border-bottom-width: 0px !important;\n        .dqoi-logo{\n            min-height:40px;\n            min-width:40px;\n            height:40px;\n            width:40px;\n            overflow: hidden;\n            margin-left: 30px;\n            border-radius:var(--border-m-radius);\n            img{height:40px;}\n            .no-logo{\n                background-color: var(--light-grey);\n                box-shadow: inset 0px 0px 0px 1px var(--border-color);\n            }\n        }\n        .dqoi-panel-customer-info{\n            max-width:326px;\n            width:100%;\n            display:flex;\n            flex-direction: column;\n            flex-wrap: nowrap;\n            padding-right:20px;\n            margin: 0px 13px 0px 20px;\n            border-right:var(--border-style);\n            #customer-name{\n                font-size: 14px;\n                font-weight: 700;\n                max-width: 326px;\n                height: 20px;\n                line-height: 20px;\n                color:var(--primary-font-color);\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n            #customer-location{\n                font-size:12px;\n                font-weight:400;\n                max-width: 326px;\n                height:20px;\n                line-height:20px;\n                color:var(--primary-font-color);\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n        }\n        .dqoi-panel-dqoi-info-wrap {\n            display: flex;\n            flex-flow: row wrap;\n            width: 100%;\n            .dqoi-panel-dqoi-info {\n                flex-grow:1;\n                margin: 0px 13px;\n                max-width: 150px;\n                .dqoi-label {\n                    font-weight: 500;\n                    font-size: 10px;\n                    width: 100%;\n                    height: 18px;\n                    line-height: 18px;\n\n                    .dqoi-panel-priority {\n                        width: 8px;\n                        height: 8px;\n                        border-radius: 50%;\n                        line-height: 18px;\n                        top: -13px;\n                        position: relative;\n                        left: 50px;\n                    }\n                }\n\n                .dqoi-info {\n                    font-color:var(--primary-font-color);\n                    font-weight: 500;\n                    font-size: 10px;\n                    width: 100%;\n                    height: 20px;\n                    line-height: 20px;\n                    span{\n                        &:first-child{\n                            margin-right:10px;\n                            font-weight: 600;\n                        }\n                    }\n                }\n            }\n        }\n        .mat-expansion-panel-body{\n            padding:0px !important;\n        }\n        .mat-expansion-panel-header-title{\n            width:95%;\n            display: flex;\n        }\n        .dqoi-panel-controls{\n            display: flex;\n            flex-flow: row nowrap;\n            cp-loader{\n                margin-right: 20px;\n            }\n        }\n    }\n}*/\n\n/*.control-bar{\n    width:100%;\n    display: flex;\n    flex-flow: row wrap;\n    padding:0px 0px;\n    //margin:-10px 0px 0px;\n    margin:0px 20px 0px;\n    .tab-type{\n        flex-grow:2;\n        display: flex;\n        flex-flow: row nowrap;\n        button{margin-right:10px;}\n        h1{\n            font-size:16px;\n            font-weight:800;\n        }\n    }\n    .control-btns {\n        flex-grow:1;\n        display: flex;\n        flex-flow: row wrap;\n        align-items: center;\n        justify-content: flex-end;\n        .btn-wrap {\n            margin: 0px 10px;\n        }\n        .separator {\n            width: 1px;\n            height: 30px;\n            background-color: var(--border-color);\n            margin: 0px 10px;\n        }\n        .edit-save-btn {\n            width: 130px;\n            margin: 0px 0px 0px 10px;\n\n            button {\n                width: 100%;\n            }\n\n            span {\n                button {\n                    width: calc(50% - 10px);\n                }\n\n                &:first-child {\n                    margin-right: 10px;\n                }\n\n                &:last-child {\n                    margiht-left: 10px;\n                }\n            }\n        }\n    }\n}*/\n\n.featured-box-wrap{\n    display: flex;\n    flex-flow:row wrap;\n    padding:13px 0px 0px;\n    margin:10px 0;\n    border-radius: var(--border-m-radius);\n    .featured-box{\n        width:100%;\n        border:var(--border-style);\n        background-color:var(--light-grey);\n        padding:13px;\n        //margin:11px 13px;\n        h1{\n            font-size:14px;\n            font-weight:900;\n            color:var(--secondary-font-color);\n            margin: 0;\n        }\n        /*&.last-update{\n            .cp-input-container{\n                margin:10px 0 0;\n                p{\n                    margin:0;\n                }\n            }\n        }*/\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
